import React, { useState } from 'react';
import './CarsSearch.css';

import { PriceFilter, SidebarHeading } from '../../components';
import { cars } from '../../constants';



const CarsSearch = ({ onFilterChange, filters }) => {

  // Local state for price range to manage the slider UI
  const [localPriceRange, setLocalPriceRange] = useState({
    min: filters.priceRange[0],
    max: filters.priceRange[1]
  });

  // Extract unique values for each filter category from cars data
  const getUniqueValues = (key, isArray = false) => {
    const values = new Set();
    cars.forEach(car => {
      if (isArray) {
        car.details[key].forEach(item => values.add(item.toLowerCase()));
      } else {
        values.add(car.details[key].toLowerCase());
      }
    });
    return Array.from(values).sort();
  };

  // Get all unique values for each filter
  const allBrands = getUniqueValues('brand');
  const allTypes = getUniqueValues('type');
  const allTransmissions = getUniqueValues('transmission', true);
  const allFuels = getUniqueValues('fuelType', true);

  const handleCheckboxChange = (category, value) => {
    const newFilters = {
      ...filters,
      [category]: filters[category].includes(value)
        ? filters[category].filter((item) => item !== value)
        : [...filters[category], value]
    };
    onFilterChange(newFilters);
  };

  const handlePriceChange = (newPriceRange) => {
    // Update local state for immediate slider response
    setLocalPriceRange(newPriceRange);

    // Update the actual filters after a slight delay (for better UX with sliders)
    const timer = setTimeout(() => {
      const newFilters = {
        ...filters,
        priceRange: [newPriceRange.min, newPriceRange.max]
      };
      onFilterChange(newFilters);
    }, 300);

    return () => clearTimeout(timer);
  };

  return (

    <div className="car-search sidebar">

      {/* Car Brand Filter */}
      <div className="car-features sidebar-item">
        <SidebarHeading title='Car Brand' />
        {allBrands.map((brand) => (
          <div className="checkbox-label" key={brand}>
            <input
              type="checkbox"
              id={brand}
              name="car-specification[]"
              value={brand}
              checked={filters.brands.includes(brand)}
              onChange={() => handleCheckboxChange('brands', brand)}
            />
            <label htmlFor={brand}>
              {brand.charAt(0).toUpperCase() + brand.slice(1)}
            </label>
            <div className="checkbox-indicator"></div>
          </div>

        ))}
      </div>

      {/* Car Type Filter */}
      <div className="car-features sidebar-item">
        <SidebarHeading title='Car Type' />
        {allTypes.map((type) => (
          <div className="checkbox-label" key={type}>
            <input
              type="checkbox"
              id={type}
              name="car-specification[]"
              value={type}
              checked={filters.types.includes(type)}
              onChange={() => handleCheckboxChange('types', type)}
            />
            <label htmlFor={type}>
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </label>
            <div className="checkbox-indicator"></div>
          </div>
        ))}
      </div>

      {/* Transmission Filter */}
      <div className="car-features sidebar-item">
        <SidebarHeading title='Transmission' />
        {allTransmissions.map((transmission) => (
          <div className="checkbox-label" key={transmission}>
            <input
              type="checkbox"
              id={transmission}
              name="car-specification[]"
              value={transmission}
              checked={filters.transmissions.includes(transmission)}
              onChange={() => handleCheckboxChange('transmissions', transmission)}
            />
            <label htmlFor={transmission}>
              {transmission.charAt(0).toUpperCase() + transmission.slice(1)}
            </label>
            <div className="checkbox-indicator"></div>
          </div>
        ))}
      </div>

      {/* Fuel Type Filter */}
      <div className="car-features sidebar-item">
        <SidebarHeading title='Fuel' />
        {allFuels.map((fuel) => (
          <div className="checkbox-label" key={fuel}>
            <input
              type="checkbox"
              id={fuel}
              name="car-specification[]"
              value={fuel}
              checked={filters.fuels.includes(fuel)}
              onChange={() => handleCheckboxChange('fuels', fuel)}
            />
            <label htmlFor={fuel}>
              {fuel.charAt(0).toUpperCase() + fuel.slice(1)}
            </label>
            <div className="checkbox-indicator"></div>
          </div>
        ))}
      </div>

      {/* Price Filter */}
      <div className="sidebar-item">
        <SidebarHeading title='Price Range' />
        <PriceFilter 
          priceRange={localPriceRange}
          setPriceRange={handlePriceChange}
          rangeInputMax={400}
        />
      </div>

    </div>
  );
};

export default CarsSearch;